module.exports = __webpack_public_path__ + "img/pizzaset-809.7da44434.png";